// 渲染定位
import React, {memo} from 'react'
import styled from 'styled-components'
import locationImg from "../../img/location.png";
const LocationWords = styled.div`
  span {
    display: inline-block;
    margin-top: 8px;
    margin-left: 4px;
    color: #595959;
    font-size: 12px;
  }
`
const RenderLocation = memo((props) => {
  const {value} = props
  let message = value.messageContent ? JSON.parse(value.messageContent) : {}
  return (
    <LocationWords>
      <img src={locationImg} alt="定位"/>
      <span>{message.address}</span>
    </LocationWords>
  )
})

export default RenderLocation
